module.exports = __webpack_public_path__ + "d4675c6a85987e8b8e34e23a6e687fd7.jpg";